export function isOptionObject(opt) {
  return opt != null && typeof opt === 'object';
}

export function getOptionValue(opt) {
  if (isOptionObject(opt)) return opt.value ?? opt.code ?? opt.id ?? opt._id ?? opt.label;
  return opt;
}

export function getOptionLabel(opt) {
  if (isOptionObject(opt)) return opt.label ?? String(getOptionValue(opt) ?? '');
  return String(opt ?? '');
}

export function getOptionDisabled(opt) {
  if (isOptionObject(opt)) return Boolean(opt.disabled);
  return false;
}

export function coerceMultiValue(value) {
  if (Array.isArray(value)) return value;
  if (value == null || value === '') return [];
  return [value];
}

